// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".workspace-selector-toggle--D6J4W{font-weight:500;max-width:100%}.workspace-selector-toggle--D6J4W span{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dropdown:has(.workspace-selector-toggle--D6J4W){display:block;width:100%}.workspace-selector-toggle--D6J4W~.dropdown-menu{width:100%;min-width:0}.workspace-selector-toggle--D6J4W~.dropdown-menu .dropdown-item{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspace-selector-toggle": "workspace-selector-toggle--D6J4W"
};
export default ___CSS_LOADER_EXPORT___;
